import React, { useEffect, useRef, useState, lazy, Suspense, memo, useCallback } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

// @utility
import loadImagesFetch from "../../../../../../@utility/app/loadImagesFetch";

// Redux
import { setHideHomeFooter } from "../../../../../../@core/redux/actions/home/index";
import { setDataPosition } from "../../../../../../@core/redux/actions/app/scrollPosition";
import { setLoadImages } from "../../../../../../@core/redux/actions/app/processing";

// CSS
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

/* =========================
 * Lazy Components
 * ========================= */
const ListGame = lazy(() => import("./ListGame"));
const ListRank = lazy(() => import("./ListRank"));
const ListRankWithdraw = lazy(() => import("./ListRankWithdraw"));
const ListPromotion = lazy(() => import("./ListPromotion"));
const ListEntertain = lazy(() => import("./ListEntertain"));
const ListUserRank = lazy(() => import("../../iframe-rank/component/ListUserRank"));
const MenuHomeContent = lazy(() => import("./SectionHome"));

/* =========================
 * Helper
 * ========================= */
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography component={"span"}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        "aria-controls": `vertical-tabpanel-${index}`,
    };
}

function LinkTab(props) {
    return (
        <Tab
            component="a"
            onClick={(event) => {
                event.preventDefault();
            }}
            {...props}
        />
    );
}

/* =========================
 * Styles
 * ========================= */
const useStyles = makeStyles((theme) => ({
    contentPosition: {
        width: "100%",
        height: "100%",
    },
    cardBody: {},
    cardOther: {
        [theme.breakpoints.down("md")]: {
            paddingLeft: "10px",
            paddingRight: "10px",
        },
        [theme.breakpoints.down("xs")]: {
            paddingLeft: "6px",
            paddingRight: "6px",
        },
    },
    heightMenu: {
        height: "100%",
    },
    tabs: {
        height: "930px",
        [theme.breakpoints.down("xs")]: {
            height: "464px",
        },
    },
    widthMenuLeft: {
        width: "14%",
        [theme.breakpoints.down("md")]: {
            width: "20%",
        },
        [theme.breakpoints.down("sm")]: {
            width: "22%",
        },
    },
    widthMenuRight: {
        width: "86%",
        [theme.breakpoints.down("md")]: {
            width: "80%",
        },
        [theme.breakpoints.down("sm")]: {
            width: "78%",
        },
    },
    menuContent: {
        width: "100%",
        height: "100%",
    },
    lazyFallback: {
        width: "100%",
        padding: "12px 0",
    },
}));

function ContentHome({ processing, loadComponent, setLoadComponent }) {
    const dataSetting = useSelector((state) => state.reduxAppMenu.menu_items);
    //   const dataMenu = useSelector((state) => state.reduxHome.menu);
    const homeProcessing = useSelector((state) => state.reduxAppProcessing.home);
    const reduxAppCMS = useSelector((state) => state.reduxAppCMS.cms);
    const promotionData = useSelector((state) => state.reduxPromotion.promotionItem);
    const imagesProcessing = useSelector((state) => state.reduxAppProcessing.images);

    const history = useHistory();
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));
    const dispatch = useDispatch();

    const gameListRef = useRef(null);
    const scrollRef = useRef(null);

    const [menuList, setMenuList] = useState(null);

    const classes = useStyles();

    const selectPageHome = useCallback(
        (item) => {
            if (!item?.code || item?.code === "home") return;
            history.push(`/game/${item.code}`);
        },
        [history]
    );

    useEffect(() => {
        if (processing && loadComponent === false) {
            setLoadComponent(true);
        }
    }, [processing, loadComponent, setLoadComponent]);

    useEffect(() => {
        if (!homeProcessing) return undefined;

        const timer = setTimeout(() => {
            const statusLoad = loadImagesFetch(2);
            if (statusLoad && scrollRef.current?.offsetTop !== undefined) {
                const positionTop = scrollRef.current.offsetTop - 100;
                dispatch(setDataPosition(positionTop));
                dispatch(setLoadImages(statusLoad));
            }
        }, 500);

        return () => clearTimeout(timer);
    }, [homeProcessing, dispatch]);

    // ✅ ไม่มีเมนู -> redirect "/"
    useEffect(() => {
        const menuArr = dataSetting?.menu_camp;
        const hasMenu = Array.isArray(menuArr) && menuArr.length > 0;

        if (hasMenu) {
            setMenuList(menuArr);
        }
        else {
            setMenuList([
                {
                    "id": 1,
                    "at": 0,
                    "name": "หน้าหลัก",
                    "code": "home",
                    "title": "หน้าหลัก",
                    "image": "https://cdn.w800u900.com/system/menu-home-type-a/Home.webp",
                    "game_camp_type": 99,
                    "game_camp_type_name": "Home",
                    "game_camp_image": false,
                    "column_desktop": 6,
                    "column_mobile": 12,
                    "status": 1
                }
            ]);
        }
    }, [dataSetting?.menu_camp, history]);

    useEffect(() => {
        dispatch(setHideHomeFooter(true));
    }, []);

    // ✅ ไม่มีเมนู = ไม่ render อะไร (เพราะ redirect แล้ว)
    if (!menuList) return null;

    return (
        <div className={classes.contentPosition}>
            <div className="boxGame">
                <div
                    className={classes.cardBody}
                    ref={scrollRef}
                    style={{ background: reduxAppCMS !== null ? reduxAppCMS["bg-foter"] : "black" }}
                >
                    <div className={classes.cardOther}>
                        <Grid container spacing={isLargeScreen ? 2 : 1}>
                            <Grid item className={[classes.heightMenu, classes.widthMenuLeft].join(" ")}>
                                <Tabs
                                    orientation="vertical"
                                    variant="scrollable"
                                    value={0}
                                    className={classes.tabs}
                                >
                                    {menuList.map((item, index) => (
                                        <LinkTab
                                            key={item?.code || index}
                                            label={
                                                item?.image ? (
                                                    <div className="homeMenuIconFullPadding">
                                                        <img className="homeMenuIconFull" src={item.image} alt={item.name} />
                                                    </div>
                                                ) : (
                                                    <div className="homeMenuText">{item.name}</div>
                                                )
                                            }
                                            {...a11yProps(index)}
                                            onClick={() => selectPageHome(item)}
                                        />
                                    ))}
                                </Tabs>
                            </Grid>

                            <Grid item className={classes.widthMenuRight}>
                                <div className={classes.menuContent}>
                                    <Suspense fallback={null}>
                                        <MenuHomeContent />
                                    </Suspense>
                                </div>
                            </Grid>
                        </Grid>
                    </div>

                    {/* ✅ ครอบด้วย Suspense เพราะ List* เป็น lazy */}
                    {homeProcessing && imagesProcessing && reduxAppCMS !== null && (
                        <Suspense fallback={null}>
                            <>
                                {(reduxAppCMS?.section_games_rank === "1" || reduxAppCMS?.section_games_rank === 1) && (
                                    <div className="cardMargin relative" ref={gameListRef}>
                                        <div className="left">
                                            <ListRank pageName="10 อันดับเกมยอดนิยมประจำวัน" />
                                        </div>
                                    </div>
                                )}

                                {(reduxAppCMS?.section_casino === "1" || reduxAppCMS?.section_casino === 1) && (
                                    <div className="cardMargin relative">
                                        <div className="left">
                                            <ListGame pageType="casino" pageName="ค่ายเกมไลฟ์สด" />
                                        </div>
                                    </div>
                                )}

                                {(reduxAppCMS?.section_promoiton === "1" || reduxAppCMS?.section_promoiton === 1) && (
                                    <div className="cardMargin relative">
                                        <div className="left">
                                            <ListPromotion pageName="โปรโมชั่น" promotionData={promotionData} />
                                        </div>
                                    </div>
                                )}

                                {(reduxAppCMS?.section_user_rank === "1" || reduxAppCMS?.section_user_rank === 1) && (
                                    <div className="cardMargin relative">
                                        <div className="left">
                                            <ListUserRank pageName="การจัดอันดับรางวัล" />
                                        </div>
                                    </div>
                                )}

                                {(reduxAppCMS?.section_withdraw_rank === "1" || reduxAppCMS?.section_withdraw_rank === 1) && (
                                    <div className="cardMargin cardMarginOther relative">
                                        <div className="left">
                                            <ListRankWithdraw pageName="รายงานผลอันดับการถอนเงิน" />
                                        </div>
                                    </div>
                                )}

                                {(reduxAppCMS?.section_entertainment === "1" || reduxAppCMS?.section_entertainment === 1) && (
                                    <div className="cardMargin relative">
                                        <div className="left">
                                            <ListEntertain pageName="ความบันเทิงเต็มรูปแบบ" />
                                        </div>
                                    </div>
                                )}
                            </>
                        </Suspense>
                    )}
                </div>
            </div>
        </div>
    );
}

ContentHome.propTypes = {
    processing: PropTypes.bool,
    loadComponent: PropTypes.bool,
    setLoadComponent: PropTypes.func,
};

export default memo(ContentHome);
